module.exports = "/_next/static/images/Hero@2x-3ee90c78e1f96bbe07603e11e768a61c.webp";